import React from 'react';

import { injectedHook, useText } from '@base/core';
import { useUrlParams } from '../../../shared/hooks/useUrlParams';

export default injectedHook(
  {
    name: 'useDetectPredefinedNotifications',
    services: ['notifier', 'dialog'],
  },
  function useDetectPredefinedNotifications({ services }) {
    const { notifier, dialog } = services;
    const text = useText();
    const { removeUrlParams, getUrlParam } = useUrlParams();

    const createDialogParams = (email, action, memberId, utmSource, partnerId) => {
      return btoa(JSON.stringify({
        email,
        action,
        memberId,
        isFirstLaunch: false,
        utm_source: utmSource || '',
        partnerId: partnerId || ''
      }));
    };

    const showContinuationNotification = (email, action, memberId, utmSource, partnerId) => {
      const signupContinuationMessage = text('dialog.signup.continuation_message');
      const continueButtonText = text('dialog.signup.continue');
      notifier.push(signupContinuationMessage, {
        handler: () => {
          try {
            notifier.closeAll();
            const dialogParams = createDialogParams(email, action, memberId, utmSource, partnerId);
            dialog.open('SessionKeyDialog', dialogParams);
          } catch (error) {
            console.error('Error opening SessionKeyDialog:', error);
          }
        },
        buttonText: continueButtonText,
        timeless: true
      });
    };

    const checkUrlParameters = () => {
      const searchParams = new URLSearchParams(window.location.search);

      const error = searchParams.get('error');
      if (error) {
        return false;
      }

      const continuationEmail = searchParams.get('continuation_email');
      const continuationMemberId = searchParams.get('continuation_memberId');
      const continuationAction = searchParams.get('continuation_action');

      if (continuationEmail && continuationMemberId && continuationAction === 'signup') {
        showContinuationNotification(
          continuationEmail,
          continuationAction,
          continuationMemberId,
          searchParams.get('utm_source'),
          searchParams.get('partner')
        );
        return true;
      }

      const action = searchParams.get('action');
      const memberId = searchParams.get('memberId');
      const email = searchParams.get('email');

      if (action === 'signup' && memberId && email) {
        const dialogParams = createDialogParams(email, action, memberId, searchParams.get('utm_source'), searchParams.get('partner'));
        dialog.open('SessionKeyDialog', dialogParams);
        
        removeUrlParams(['action', 'memberId', 'email', 'attemptsLeft', 'checkResult']);
        return true;
      }

      return false;
    };

    return () => {
      checkUrlParameters();
    };
  }
);
